import React from 'react';
import './ToggleSwitch.css';

// Shared on/off switch for boolean settings (see ui-architecture.md's
// Yes/No Settings section) — a sliding track reads unambiguously as
// "on/off" without competing visually with a required-field checkmark,
// unlike a plain <input type="checkbox">. Wraps a real checkbox input for
// native form/accessibility semantics; only the track+thumb are custom.
function ToggleSwitch({ checked, onChange, label, disabled, title }) {
  return (
    <label className="toggle-switch-row" title={title} style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}>
      <span className="toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="toggle-slider" />
      </span>
      {label && <span className="toggle-switch-label">{label}</span>}
    </label>
  );
}

export default ToggleSwitch;
